module.exports = __webpack_public_path__ + "a8a10a3e/img/mini-logo.18817ee5.svg";